<template>
    <main>

        <div class="list-cart-container">
            <div class="list-cart-content list-cart-content-coupon" v-if="dataCoupons.length">
                <div class="list-cart-item coupons-round-container" style="min-width: 350px; margin: 10px 1px;" v-for="(coupon, i) in dataCoupons" :key="i+1">
                    <span class="J-delete-btn"><i class="fas fa-times"></i></span>
                    <div class="list-cart-title">
                         <span v-if="coupon.percentage!=0">Cupón <b>{{coupon.name}} </b> <b>{{coupon.percentage}}% </b>de descuento del total</span>
                         <span v-else>Cupón <b>{{coupon.name}} </b></span>
                    </div>
                    <div class="list-cart-body">
                        <div v-if="coupon.additionals.length!=0">
                            <span>Contiene servicios gratis como:</span>
                            <div  class="list-custom-fill">
                                <div class="list-custom-fill-item" v-for="(additional,e) in coupon.additionals" :key="e+1">
                                    {{additional.name}}
                                    <span class="J-delete-btn"><i class="fas fa-check"></i></span>
                                </div>
                            </div>
                        </div>
                        <div v-if="coupon.amount">
                            <div>
                                Cantidad de cupones {{coupon.amount}}
                            </div>
                            <div>
                                Restantes {{coupon.remaining_amount}}
                            </div>
                        </div>
                    </div>
                    <div class="list-cart-center">
                        <span class="list-cart-title-primary"> <span class="title-min">Código:</span> {{coupon.key}}</span>
                        
                        <span>
                            <button class="J-btn-primary J-m-l-10" @click="apply(coupon)">Aplicar</button>
                        </span>
                        <!-- <span class="J-btn-copy"> <i class="fas fa-copy" @click="copyLink(coupon)"></i></span> -->
                    </div>
                    <div class="list-cart-bottom">
                        <div class="list-cart-bottom-left">
                             {{moment(coupon.date_start).format("YYYY-MM-DD HH:mm")}}
                        </div>
                        <div class="list-cart-bottom-right">
                             {{moment(coupon.date_end).format("YYYY-MM-DD HH:mm")}}
                        </div>
                    </div>

                    <div class="coupons-round-left">

                    </div>
                    <div class="coupons-round-right">

                    </div>
                </div>
            </div>
            <div v-else>
                El negocio no tiene cupones disponible.
            </div>
        </div>
    </main>
</template>
<script>
import moment from 'moment'
const alertify = require('alertifyjs')
moment.locale('es');
export default {
    data(){
        return{
            moment:moment,
        }   
    },
    mounted(){
        
    },
    methods:{
        apply(data){
            this.$emit("action",data)
        },
        copyLink:function(data){
            var URLdomain = window.location.origin;
            this.copyTextClipBoard(`${URLdomain}/?coupon=${data.key}&&company=${this.company.id}`);
        },
        copyTextClipBoard:function(text){
            if(!navigator.clipboard){
                this.fallbackCopyTextToClipboard(text);
                return;
            }
            navigator.clipboard.writeText(text)
            .then(()=>{
                alertify.success('copiado');
            })
        },
    },
    props:{
        dataCoupons:{required:false,default:[]},
        company:{required:false,default:null},
    }
}
</script>